function formSelect(container) {
  const formContext = document.querySelector(container);
  if(!formContext) return;

  let productSelect;

  _init();


  function _init() {
    productSelect = formContext.querySelector('[product-select]');
    _resetForms();

    let radios = [].slice.call(productSelect.querySelectorAll('input[type=radio]'));

    // Listen for changes in radios
    radios.forEach(function(radio) {
      radio.addEventListener('change', function(event) {
        let product = event.target.value,
          productData;

        _resetForms();
        _setProductHidden(product);

        productData = _getContext(product);
        _setAfterContent(productData.textAfter);
        _setOptions(productData.forms);
        _setPortalLinks(productData.text);
        formContext.classList.add('product-select--active');

        var url = window.location.href;
        var param = 'produkt';
        var paramValue = product;

        let urlParams = new URLSearchParams(window.location.search);
        urlParams.set(param, paramValue);
        let newURL = `${url.split('?')[0]}?${urlParams.toString()}`;
        window.history.pushState({ path: newURL }, '', newURL);
      });
    });

    document.addEventListener("DOMContentLoaded", (event) => {
      let checkedRadio = productSelect.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        let product = checkedRadio.value,
            productData;
        _resetForms();
        _setProductHidden(product);

        productData = _getContext(product);
        _setAfterContent(productData.textAfter);
        _setOptions(productData.forms);
        _setPortalLinks(productData.text);
        formContext.classList.add('product-select--active');
      }
    })
  }

  function _getContext(category) {
    // variable will be rendered with page in script tag by backend
    return formContextOptions[category];
  }

  function _setOptions(options) {
    let selectContainer = formContext.querySelector('div[form-select]');
    let select = formContext.querySelector('div[form-select] select');

    let currentSelect = formContext.querySelector('div[form-select] details');
    if (currentSelect !== null) {
      currentSelect.remove();
    }

    // Check if there's a previous selection
    if(!select) {
      select = document.createElement('select');
      select.setAttribute('form-select', '');
      select.setAttribute('class', 'powermail_select');
    } else {
      select.innerHTML = '';
    }

    // Default selection
    let defaultOption = document.createElement('option');
    defaultOption.innerHTML = '-- bitte auswählen --';
    defaultOption.disabled = true;
    defaultOption.selected = true;
    select.appendChild(defaultOption);

    // Populate select field
    options.forEach(function(option) {
      let optionElement = document.createElement('option');
      optionElement.innerHTML = option.content;
      optionElement.value = option.id;
      select.appendChild(optionElement);
    });

    selectContainer.appendChild(select);
    productSelect.parentElement.insertBefore(selectContainer, productSelect.nextSibling);
    
    let preselectionId;
    if(options.length === 1) {
      preselectionId = options[0].id;
    }

    // Listen to changes in select field
    window.coma.select.createSelect(select, function(event) {
      let id = event.target.value;
      _setForm(id);
    }, preselectionId);

    // Set form as active, if preselection exists
    if(preselectionId) _setForm(preselectionId);
  }

  function _setPortalLinks(links) {
    let container = formContext.querySelector('[portal-links]');

    if(!container) {
      container = document.createElement('div');
      container.setAttribute('portal-links', '');
      container.classList.add('portal-links');
    } else {
      container.innerHTML = '';
    }

    container.innerHTML = links;
    productSelect.parentElement.insertBefore(container, productSelect.nextSibling);
  }

  function _setAfterContent(content) {
    if (content == '') {
      return;
    }

    let container = formContext.querySelector('[after-content]');

    if (!container) {
      container = document.createElement('div');
      container.setAttribute('after-content', '');
      container.classList.add('after-content');
    } else {
      container.innerHTML = '';
    }

    container.innerHTML = content;
    productSelect.parentElement.insertBefore(container, productSelect.nextSibling);
  }

  function _setForm(id) {
    let forms = [].slice.call(document.querySelectorAll('form'));

    // Hide irrelevant forms
    forms.forEach(function(form) {
      if(form.id === 'form-' + id) {
        form.removeAttribute('filter-hidden');
      } else {
        form.setAttribute('filter-hidden', '');
      }
    });
  }

  function _resetForms() {
    let forms = [].slice.call(document.querySelectorAll('form'));

    // Hide all forms
    forms.forEach(function(form) {
      form.setAttribute('filter-hidden', '');
    });
  }

  function _setProductHidden(product) {
    if (productNames[product] !== undefined) {
      let hiddenFields = [].slice.call(document.querySelectorAll('input[type=hidden]'));
      hiddenFields.forEach(function(input) {
        if (input.name == 'tx_powermail_pi1[field][product]') {
          input.value = productNames[product];
        }
      });
    }
  }
}

formSelect('[form-context-select]');
